import React, {Component} from "react";
import {ORDER_ADMIN_ROUTE} from "../../../../utils/constants/RoutesConstants";
import TakeOrderAdmin from "./TakeOrderAdminView";
import {OrderAdminService} from "../../../../service/operation/orderAdmin/OrderAdminService";
import {Growl} from "primereact/growl";

export default class TakeOrderAdminContainer extends Component {
    constructor(props) {
        super(props);

        this.orderAdminService = new OrderAdminService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataOrderTrade = this.saveDataOrderTrade.bind(this);
        this.takeOrderAdmin = this.takeOrderAdmin.bind(this);
        this.updateRateAndSurchargeValue = this.updateRateAndSurchargeValue.bind(this);

        this.state = {
            isLoading: false,
            orderTrade: this.props.location.state.selectedOrderAdmin,
        };

        this.accountDropDown = React.createRef();

        this.updateRateAndSurchargeValue();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: ORDER_ADMIN_ROUTE,
            message: message,
        });
    }

    updateRateAndSurchargeValue() {
        let order = this.state.orderTrade;

        order.tasa = order.tasa * 100;
        order.sobreTasa = order.sobreTasa * 100;
        this.setState({
            orderTrade: order,
        })
    }

    saveDataOrderTrade(event) {
        const {name, value} = event.target;
        let orderTrade = this.state.orderTrade;
        orderTrade[name] = value;

        if (name === "catInstitutionLender") {
            this.loading(true);
            this.accountDropDown.current.getInstitutionAccountsById(value.idInstitucion);
            orderTrade['catAccount'] = {};
        }

        this.setState({orderTrade: orderTrade,})
    }

    takeOrderAdmin() {
        this.loading(true);
        if (this.state.orderTrade.nomCortoPtm === '') {
            let fieldsLender = this.validateLenderFields();
            if (fieldsLender.length === 0) {
                this.orderAdminService.insertLenderOrderAdmin(
                    this.state.orderTrade.catInstitutionLender.idInstitucion,
                    this.state.orderTrade.idEmision,
                    this.state.orderTrade.catAccount.cuenta,
                    this.state.orderTrade.cantidad,
                    this.state.orderTrade.plazo,
                    this.state.orderTrade.tasa * 100,
                    this.state.orderTrade.sobreTasa * 100,
                    this.state.orderTrade.vigencia === 0 ? 'D' : 'S',
                    this.state.orderTrade.fecValor,
                    this.state.orderTrade.idFolioSolVal
                ).then(res => {
                    if (res.message && res.message !== '') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: res.message,
                        };
                        this.handleReturnButton(message);
                    } else if (res.error && res.error !== '') {
                        this.loading(false);
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
            } else {
                this.loading(false);
                this.showMessage(fieldsLender);
            }
        } else {
            let fieldsBorrower = this.validateBorrowerFields();
            if (fieldsBorrower.length === 0) {
                this.orderAdminService.insertBorrowerOrderAdmin(
                    this.state.orderTrade.catInstitutionBorrower.idInstitucion,
                    this.state.orderTrade.idEmision,
                    this.state.orderTrade.cantidad,
                    this.state.orderTrade.plazo,
                    this.state.orderTrade.tasa * 100,
                    this.state.orderTrade.sobreTasa * 100,
                    this.state.orderTrade.vigencia === 0 ? 'D' : 'S',
                    this.state.orderTrade.fecValor,
                    this.state.orderTrade.idFolioValPrestable
                ).then(res => {
                    if (res.message && res.message !== '') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: res.message,
                        };
                        this.handleReturnButton(message);
                    } else if (res.error && res.error !== '') {
                        this.loading(false);
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
            } else {
                this.loading(false);
                this.showMessage(fieldsBorrower);
            }
        }
    }

    validateLenderFields() {
        let fieldsLender = [];


        if (this.state.orderTrade.catInstitutionLender === undefined) {
            fieldsLender.push("Prestamista");
        }

        if (this.state.orderTrade.catAccount === undefined || this.state.orderTrade.catAccount.cuenta === undefined) {
            fieldsLender.push("Cuenta");
        }

        return fieldsLender;
    }

    validateBorrowerFields() {
        let fieldsBorrower = [];

        if (this.state.orderTrade.catInstitutionBorrower === undefined) {
            fieldsBorrower.push("Prestatario");
        }

        return fieldsBorrower;
    }

    showMessage(fields) {
        let message = "Favor de revisar los siguientes campos: ";

        fields.map(field => {
            message = message + field + ', ';
            return '';
        });

        let lastTwoChar = message.slice(-2);

        if (lastTwoChar === ', ') {
            message = message.slice(0, -2);
        }

        this.growl.show({severity: 'error', summary: 'Error.', detail: message});
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <TakeOrderAdmin
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            accountDropDown={this.accountDropDown}
            orderTrade={this.state.orderTrade}
            saveDataOrderTrade={this.saveDataOrderTrade}
            takeOrderAdmin={this.takeOrderAdmin}
        />
    }
};